import { askWorkEngagement } from './timerFlow';
import { engagementRequiredOptions } from './timerModel';

/**
 * FU-53 (D-146 Q-98, MERGE-INT7) — a MANUAL work log on a ticket without an
 * engagement asks "לאיזו התקשרות לרשום את השעות?", exactly like "התחלת
 * עבודה": the server answers 409 ENGAGEMENT_REQUIRED with the customer's
 * active engagements (one active service engagement is chosen by itself), the
 * same dialog asks, and the save is sent again with the chosen engagement.
 * Returns null when the employee closed the question (nothing was saved).
 */
export async function withWorkEngagement<T>(
  task: { id: string; title?: string | null },
  send: (engagementId?: string) => Promise<T>
): Promise<T | null> {
  try {
    return await send();
  } catch (err) {
    const options = engagementRequiredOptions(err);
    if (options === null) throw err;
    const chosen = await askWorkEngagement({ task: { id: task.id, title: task.title || '' }, engagements: options, mode: 'log' });
    if (!chosen) return null;
    return send(chosen);
  }
}
